var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header display-inline",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center form-ui-title display-inline"
            },
            [
              _c("img", {
                staticClass: "back-to-list-apps",
                staticStyle: { "vertical-align": "top" },
                attrs: { src: require("@/assets/icon/arrow-left.svg") },
                on: {
                  click: function($event) {
                    _vm.$router.push("/ai")
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column m__l--10 display-inline",
                  staticStyle: { "max-width": "285px" }
                },
                [
                  _c(
                    "h3",
                    { staticClass: "label-header-form-ui ellipsis m--0" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.detailAi ? _vm.detailAi.name : "") +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-size": "12px" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.detailAi ? _vm.detailAi.id : "") +
                        "\n        "
                    )
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between display-inline info-action",
              staticStyle: {
                "border-left": "1px solid #E7E7E7",
                "vertical-align": "top"
              }
            },
            [
              _c("div", { staticClass: "display-inline" }, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-items-center",
                    staticStyle: { "flex-flow": "nowrap" }
                  },
                  [
                    _c("img", {
                      staticClass: "m__l--20",
                      attrs: {
                        src: require("../../assets/icon/storage.png"),
                        height: "24"
                      }
                    }),
                    _vm._v(" "),
                    _vm.detailAi
                      ? _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column m__l--20",
                            staticStyle: {
                              "font-size": "12px",
                              "line-height": "1"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "label-header-form-ui font-weight-bold",
                                staticStyle: { "font-size": "12px" }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.detailFormData
                                        ? _vm.detailFormData.name
                                        : " "
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-size": "12px" } },
                              [_vm._v("\n              data_set\n            ")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-action-experience display-inline pull-right"
                },
                [
                  _c("i", {
                    staticClass:
                      "fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10 m__l--20",
                    attrs: { id: "configPopover" }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn pull-right m__l--10",
                      staticStyle: { background: "#E3F1FE", color: "#1A85E4" },
                      on: { click: _vm.updateAi }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-check",
                        staticStyle: { "font-size": "20px" }
                      }),
                      _vm._v("\n          Update\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-train pull-right",
                      on: {
                        click: function($event) {
                          _vm.$refs.aiTrainModal.show()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("@/assets/form-ui/train.png") }
                      }),
                      _vm._v("\n          Train\n        ")
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "experience-page-content display-inline h-100" },
        [
          _c(
            "div",
            {
              staticClass: "list-forms display-inline",
              attrs: { id: "list-form-ui" }
            },
            [
              _c(
                "div",
                { staticClass: "component-body" },
                [
                  _c("h4", [_vm._v("General")]),
                  _vm._v(" "),
                  _vm._l(_vm.sectionGeneral, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass:
                          "col-12 d-flex justify-content-between\n          component-card-form cursor-pointer align-items-end",
                        class: { active: _vm.menu_active === item.name },
                        on: {
                          click: function($event) {
                            _vm.setActiveMenu(item.name)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("img", {
                              staticClass: "m__r--16",
                              attrs: {
                                src: require("@/assets/form-ui/" +
                                  item.icon +
                                  ".png"),
                                width: "24",
                                height: "24"
                              }
                            }),
                            _vm._v(" "),
                            _c("h4", { staticClass: "title-form-component" }, [
                              _vm._v(_vm._s(item.name))
                            ])
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-ui-container display-inline" },
            [
              _vm.showComponent
                ? _c("j-ai-content", {
                    ref: "menuContent",
                    attrs: {
                      "ai-detail": _vm.detailAi,
                      "form-data": _vm.detailFormData,
                      menu: _vm.generateParam
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appCodeAiModal",
          staticClass: "mod-form modal-code-form-data",
          attrs: { centered: "" }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("VIEW CODE")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "btn-copy", on: { click: _vm.copyCode } }, [
            _c("i", {
              staticClass: "fa fa-files-o font-weight-bold cursor-pointer"
            }),
            _vm._v(" Copy\n    ")
          ]),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scroll-script" },
            [
              _c("prism-editor", {
                staticClass: "my-editor m__t--10",
                class: { "dark-mode": _vm.darkMode },
                attrs: { highlight: _vm.highlighter, "line-numbers": true },
                model: {
                  value: _vm.jsonData,
                  callback: function($$v) {
                    _vm.jsonData = $$v
                  },
                  expression: "jsonData"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("div", { staticStyle: { opacity: "0" } }, [
                  _c("textarea", {
                    ref: "viewCode",
                    attrs: { id: "view-code" },
                    domProps: { value: _vm.viewCode }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "6" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCodeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "aiTrainModal",
          staticClass: "mod-form modal-add-ai",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("ARE YOU SURE TO TRAIN ?")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.model_name.$error } },
            [
              _c("label", [_vm._v(" Model Name * ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.model_name.$error,
                  "max-length": 255,
                  palceholder: "Model Name"
                },
                model: {
                  value: _vm.$v.model_name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.model_name, "$model", $$v)
                  },
                  expression: "$v.model_name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeTrain }
                      },
                      [_vm._v("\n            No\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.actionTrainAi }
                      },
                      [_vm._v("\n            Yes\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "configPopoverRef",
          attrs: {
            show: _vm.configPopoverShow,
            target: "configPopover",
            container: "studio-page-header",
            placement: "left"
          },
          on: {
            "update:show": function($event) {
              _vm.configPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-ui-opt", on: { click: _vm.openCodeForm } },
            [_vm._v("\n      View Code\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-ui-opt", on: { click: _vm.deleteDataAi } },
            [_vm._v("\n      Delete\n    ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f7889d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f7889d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ai/jAiDetail.vue
// module id = null
// module chunks = 